import { Outlet } from 'react-router';
import { BottomNav } from '../../widgets/bottom-nav/bottom-nav.js';
import styles from './tab-layout.module.css';

/** The four top-level screens share the bar; every other screen relies on the Telegram back button. */
export const TabLayout = () => (
  <div className={styles.layout}>
    <Outlet />
    <BottomNav />
  </div>
);
